import baseApiGesttor from "../api"

export function cobrancas (idCadastro: string) {
    return baseApiGesttor.get(`/cobrancas/cliente/${idCadastro}`)
}

export function gerarQrCode (idCobranca: number) {
    return baseApiGesttor.get(`/cobrancas/qrcode/cliente/${idCobranca}`)
}